export default __webpack_public_path__ + "static/media/dota-text.0fa34d5e.png";